// extracted by mini-css-extract-plugin
module.exports = {"editUserAction":"styles_editUserAction__1nMje"};